module.exports = __webpack_public_path__ + "img/1.1e5b746f.png";